import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { environment } from '../../../environments/environment';
import { SafeErrorService } from '../services/safe-error.service';

const isAuthSessionEndpoint = (url: string) =>
  url.includes('/api/auth/login') ||
  url.includes('/api/auth/google') ||
  url.includes('/api/auth/register') ||
  url.includes('/api/auth/confirm-email') ||
  url.includes('/api/auth/verify-otp') ||
  url.includes('/api/auth/forgot-password') ||
  url.includes('/api/auth/reset-password') ||
  url.includes('/api/auth/resend-confirmation') ||
  url.includes('/api/auth/refresh') ||
  url.includes('/api/auth/logout');

const isAppApiCall = (url: string): boolean =>
  url.startsWith('/api/') || url.startsWith(environment.apiUrl);

const isSilentFallbackEndpoint = (url: string): boolean =>
  url.includes('/api/settings/runtime-limits') ||
  url.includes('/api/jivu-shell/status');

export const shouldSuppressErrorToast = (url: string, status: number): boolean =>
  isAuthSessionEndpoint(url) ||
  isSilentFallbackEndpoint(url) ||
  status === 401 ||
  (status === 0 && isAppApiCall(url));

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const safeError = inject(SafeErrorService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (shouldSuppressErrorToast(req.url, error.status)) {
        return throwError(() => error);
      }

      const errorMsg = safeError.message(error);
      toastService.show(errorMsg, 'error');
      
      return throwError(() => error);
    })
  );
};
